import React from 'react'
import useStyles from './style'
import { Grid, Typography, IconButton, Avatar } from '@mui/material'
import KeyboardArrowLeftOutlinedIcon from '@mui/icons-material/KeyboardArrowLeftOutlined'
import KeyboardArrowRightOutlinedIcon from '@mui/icons-material/KeyboardArrowRightOutlined'
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react'
// Import Swiper styles
import 'swiper/css'
// import required modules
import { Navigation } from 'swiper'
import { API_ENDPOINTS } from 'constants'
import _ from 'lodash'

// const list = [
//   {
//     id: 1,
//     img: "/assets/images/profiles/1.jpg",
//     name: "Arya stark",
//     review: `I recently visited this jewelry store and I was blown away by the selection they had. The staff were incredibly knowledgeable and helped me find the perfect piece for my husband's birthday. The prices were also very reasonable and I felt like I got a great deal. Highly recommend!`,
//   },
//   {
//     id: 2,
//     img: "/assets/images/profiles/2.jpg",
//     name: "Raajan Teejay",
//     review: `I love this jewelry store! They have a beautiful selection of unique pieces that you won't find anywhere else. The staff are always friendly and helpful, and they offer great deals and discounts regularly. I've bought several pieces from them and have never been disappointed.`,
//   },
//   {
//     id: 3,
//     img: "/assets/images/profiles/3.jpg",
//     name: "Rose Reegan",
//     review: `This jewelry store is a hidden gem! I stumbled upon it while walking through the mall and was pleasantly surprised by their selection and prices. The staff were also very friendly and helped me find the perfect necklace for a special occasion. I will definitely be returning.`,
//   },
//   {
//     id: 4,
//     img: "/assets/images/profiles/4.jpg",
//     name: "Maadhavan",
//     review: `I had an amazing experience at this jewelry store! The staff were incredibly kind and patient, helping me find the perfect engagement ring for my partner.`,
//   },
//   {
//     id: 5,
//     img: "/assets/images/profiles/5.jpg",
//     name: "Jaistar gopal",
//     review: `I highly recommend this store to anyone looking for beautiful and high-quality jewelry.`,
//   },
//   {
//     id: 6,
//     img: "/assets/images/profiles/6.jpg",
//     name: "Dhanalakshmi",
//     review: `The store was beautifully designed and the staff was friendly and helpful. `,
//   },
// ];

const Testimonials = (props) => {
  const classes = useStyles()
  const { testimonials } = props

  return (
    <>
      {!_.isEmpty(testimonials) ? (
        <Grid container className={classes.root}>
          <Grid item xs={12} className={classes.title}>
            <Typography variant="h2">What Clients Are Saying</Typography>
          </Grid>
          <Grid item xs={12}>
            <section className={classes.sliderWrapper}>
              <section className={classes.icon}>
                <IconButton size="small" component="div" className="prev">
                  <KeyboardArrowLeftOutlinedIcon />
                </IconButton>
              </section>
              {/* <section className={classes.sliderContainer}> */}
              <Swiper
                navigation={{
                  prevEl: '.prev',
                  nextEl: '.next',
                  clickable: true,
                }}
                slidesPerView={3}
                spaceBetween={24}
                //   navigation={true}
                modules={[Navigation]}
                grabCursor={true}
                className="mySwiper"
                breakpoints={{
                  50: {
                    slidesPerView: 1,
                  },
                  600: {
                    slidesPerView: 2,
                  },
                  1200: {
                    slidesPerView: 3,
                  },
                }}
              >
                {testimonials?.map((data) => (
                  <SwiperSlide key={data?.id}>
                    <section className={classes.card}>
                      <section className={classes.nameWrapper}>
                        <div className={classes.avatar}>
                          <Avatar
                            src={API_ENDPOINTS?.FILE_URL + data?.image}
                            alt={data?.name}
                          />
                        </div>{' '}
                        <div className={classes.name}>
                          <Typography variant="body1">{data?.name}</Typography>
                        </div>
                      </section>
                      <div className={classes.review}>
                        <Typography variant="body1">{data?.content}</Typography>
                      </div>
                    </section>
                  </SwiperSlide>
                ))}
              </Swiper>
              {/* </section> */}
              <section className={classes.icon}>
                <IconButton size="small" component="div" className="next">
                  <KeyboardArrowRightOutlinedIcon />
                </IconButton>
              </section>
            </section>
          </Grid>
        </Grid>
      ) : (
        <></>
      )}
    </>
  )
}

export default Testimonials
